var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 13.042L16.667 9 18 10.803 12 16l-6-5.197L7.333 9 12 13.042z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }